export const colors = {
  caribbeanGreen: '#0ED29F',
  marineBlue: '#2F62DB',
  mineGrey: '#2B2B2B',
  subtleGrey: '#B8B8B8',
  buntingBlue: '#192C58',
  mutedViolet: '#566B9C',
};
